import keycloakService from '../../keycloak_service';

import { sinatraOrigin } from '../../config';

const postToApi = async (sinatraEndpoint = '', fetchOptions = {}) => {
  const res = await fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions)
  if (!res.ok) {
    const error = new Error('Failed to load pipeline status. Try again by clicking the Refresh button.')

    // Attach extra info to the error object.
    error.info = await res.json();
    error.status = res.status;

    throw error;
  }
  return res.json();
}

export const fetchPipelineDeploymentStatus = (deploymentId, deploymentName) => {
  const params = { name: `${deploymentName}-${deploymentId}` };

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify(params),
  };

  return postToApi('v1/api/status/get_deployment', fetchOptions)
}

export default fetchPipelineDeploymentStatus;
